// Generated by ts-to-zod
import { z } from 'zod';
import { schemaDatapointBaseSchema } from './schemaDatapointBase.schema';

export const schemaDatapointStringSchema = z
  .object({
    type: z.literal('string'),
  })
  .and(schemaDatapointBaseSchema);
